import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FishIcon, AnchorIcon, ShieldIcon, TrendingUpIcon, UsersIcon, BookOpenIcon, DownloadIcon, PhoneIcon } from 'lucide-react';
export function RecursosHalieuticos() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-253">
      <Header data-id="element-254" />
      {/* Hero Section */}
      <div className="relative h-[400px] bg-cover bg-center" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1600')"
    }} data-id="element-255">
        <div className="absolute inset-0 bg-blue-900 bg-opacity-70" data-id="element-256" />
        <div className="relative h-full flex flex-col items-center justify-center text-white px-4" data-id="element-257">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-258">
            Recursos Haliêuticos
          </h1>
          <p className="text-xl text-center max-w-3xl" data-id="element-259">
            Gestão sustentável dos recursos marinhos de Cabo Verde
          </p>
        </div>
      </div>
      {/* Visão Geral do Setor */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-260">
        <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-261">
          Visão Geral do Setor Haliêutico
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-262">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-263">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-264">
              O que são Recursos Haliêuticos?
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-265">
              Os recursos haliêuticos englobam todas as espécies marinhas e de
              água doce que são objeto de pesca, aquacultura e captura. Incluem
              peixes, crustáceos, moluscos e outras espécies aquáticas de valor
              comercial e alimentar.
            </p>
            <p className="text-gray-600" data-id="element-266">
              A gestão destes recursos é fundamental para garantir a
              sustentabilidade dos ecossistemas marinhos e a segurança alimentar
              das comunidades costeiras.
            </p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-267">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-268">
              Importância para Cabo Verde
            </h3>
            <div className="space-y-4" data-id="element-269">
              <div className="flex items-start gap-3" data-id="element-270">
                <TrendingUpIcon className="w-6 h-6 text-blue-900 flex-shrink-0 mt-1" data-id="element-271" />
                <div data-id="element-272">
                  <h4 className="font-semibold text-gray-900" data-id="element-273">Económica</h4>
                  <p className="text-sm text-gray-600" data-id="element-274">
                    Contribuição significativa para o PIB e geração de emprego
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-275">
                <UsersIcon className="w-6 h-6 text-blue-900 flex-shrink-0 mt-1" data-id="element-276" />
                <div data-id="element-277">
                  <h4 className="font-semibold text-gray-900" data-id="element-278">Social</h4>
                  <p className="text-sm text-gray-600" data-id="element-279">
                    Sustento de milhares de famílias costeiras
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-280">
                <FishIcon className="w-6 h-6 text-blue-900 flex-shrink-0 mt-1" data-id="element-281" />
                <div data-id="element-282">
                  <h4 className="font-semibold text-gray-900" data-id="element-283">Ambiental</h4>
                  <p className="text-sm text-gray-600" data-id="element-284">
                    Preservação da biodiversidade marinha
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Entidades Institucionais */}
      <section className="bg-white py-16" data-id="element-285">
        <div className="max-w-7xl mx-auto px-4" data-id="element-286">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-287">
            Entidades Institucionais
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-288">
            {[{
            title: 'Direção Nacional de Pescas e Aquacultura',
            description: 'Órgão responsável pela definição e implementação de políticas do setor'
          }, {
            title: 'Instituto do Mar (IMAR)',
            description: 'Investigação científica e monitoramento dos recursos marinhos'
          }, {
            title: 'Inspeção Geral das Pescas',
            description: 'Fiscalização, controlo de qualidade e certificação'
          }, {
            title: 'Conselho Nacional de Pescas',
            description: 'Órgão consultivo para o desenvolvimento do setor'
          }, {
            title: 'Fundo Autónomo das Pescas',
            description: 'Apoio financeiro e desenvolvimento de projetos'
          }, {
            title: 'Associações de Pescadores',
            description: 'Representação e defesa dos interesses dos profissionais'
          }].map((entity, index) => <div key={index} className="bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-289">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-290">
                  {entity.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-291">{entity.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Serviços ao Setor */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-292">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-293">
          Serviços ao Setor
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-294">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-295">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-296">
              Serviços Presenciais
            </h3>
            <ul className="space-y-3" data-id="element-297">
              <li className="flex items-start gap-3" data-id="element-298">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-299" />
                <span className="text-gray-600" data-id="element-300">
                  Registo de embarcações de pesca
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-301">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-302" />
                <span className="text-gray-600" data-id="element-303">
                  Emissão de licenças e autorizações
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-304">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-305" />
                <span className="text-gray-600" data-id="element-306">
                  Monitoramento e vigilância das atividades
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-307">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-308" />
                <span className="text-gray-600" data-id="element-309">
                  Certificação de produtos da pesca
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-blue-900 text-white rounded-lg p-6" data-id="element-310">
            <h3 className="text-xl font-bold mb-4" data-id="element-311">Serviços Online</h3>
            <p className="mb-6" data-id="element-312">
              Aceda aos serviços digitais para pescadores e empresas do setor
            </p>
            <button className="bg-white text-blue-900 px-6 py-2 rounded font-semibold hover:bg-gray-100 transition-colors" data-id="element-313">
              Aceder aos Serviços
            </button>
          </div>
        </div>
      </section>
      {/* Sustentabilidade */}
      <section className="bg-white py-16" data-id="element-314">
        <div className="max-w-7xl mx-auto px-4" data-id="element-315">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-316">
            Sustentabilidade
          </h2>
          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-317">
            <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-318">
              <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600" alt="Biodiversidade Marinha" className="w-full h-full object-cover" data-id="element-319" />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-320">
                <h3 className="text-xl font-bold mb-2" data-id="element-321">
                  Programas de Biodiversidade Marinha
                </h3>
                <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-322">
                  Saber mais
                </button>
              </div>
            </div>
            <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-323">
              <img src="https://images.unsplash.com/photo-1535591273668-578e31182c4f?w=600" alt="Aquacultura" className="w-full h-full object-cover" data-id="element-324" />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-325">
                <h3 className="text-xl font-bold mb-2" data-id="element-326">
                  Programas de Aquacultura
                </h3>
                <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-327">
                  Saber mais
                </button>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-328">
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-329">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-330">
                Parcerias Internacionais
              </h4>
              <p className="text-sm text-gray-600" data-id="element-331">
                Acordos de pesca sustentável com organizações regionais e
                internacionais
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-332">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-333">
                Desenvolvimento Comunitário
              </h4>
              <p className="text-sm text-gray-600" data-id="element-334">
                Apoio às comunidades costeiras e pescadores artesanais
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-335">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-336">
                Gestão Sustentável
              </h4>
              <p className="text-sm text-gray-600" data-id="element-337">
                Práticas de pesca responsável e conservação de recursos
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Gestão Sustentável e Conservação */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-338">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-339">
          Gestão Sustentável e Conservação
        </h2>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-340">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-341">
            <ShieldIcon className="w-12 h-12 text-blue-900 mb-4" data-id="element-342" />
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-343">
              Proteção de Espécies
            </h3>
            <p className="text-gray-600 text-sm mb-4" data-id="element-344">
              Implementação de zonas de vedação e períodos de defeso para
              espécies vulneráveis
            </p>
            <a href="#" className="text-blue-900 font-semibold text-sm hover:underline" data-id="element-345">
              Ver espécies protegidas →
            </a>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-346">
            <FishIcon className="w-12 h-12 text-blue-900 mb-4" data-id="element-347" />
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-348">
              Abordagem Ecossistémica
            </h3>
            <p className="text-gray-600 text-sm mb-4" data-id="element-349">
              Gestão integrada dos recursos marinhos considerando todo o
              ecossistema
            </p>
            <a href="#" className="text-blue-900 font-semibold text-sm hover:underline" data-id="element-350">
              Saber mais →
            </a>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-351">
            <AnchorIcon className="w-12 h-12 text-blue-900 mb-4" data-id="element-352" />
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-353">
              Combate à Pesca Ilegal
            </h3>
            <p className="text-gray-600 text-sm mb-4" data-id="element-354">
              Programa de combate à pesca INN (Ilegal, Não declarada e Não
              regulamentada)
            </p>
            <a href="#" className="text-blue-900 font-semibold text-sm hover:underline" data-id="element-355">
              Denunciar →
            </a>
          </div>
        </div>
      </section>
      {/* Estatísticas */}
      <section className="bg-white py-16" data-id="element-356">
        <div className="max-w-7xl mx-auto px-4" data-id="element-357">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-358">
            Estatísticas e Dados de Captura
          </h2>
          <div className="bg-gray-50 rounded-lg p-8" data-id="element-359">
            <div className="grid md:grid-cols-4 gap-6 mb-8" data-id="element-360">
              <div className="text-center" data-id="element-361">
                <div className="text-4xl font-bold text-blue-900 mb-2" data-id="element-362">
                  15.420
                </div>
                <div className="text-sm text-gray-600" data-id="element-363">
                  Toneladas capturadas (2023)
                </div>
              </div>
              <div className="text-center" data-id="element-364">
                <div className="text-4xl font-bold text-blue-900 mb-2" data-id="element-365">
                  2.850
                </div>
                <div className="text-sm text-gray-600" data-id="element-366">
                  Embarcações registadas
                </div>
              </div>
              <div className="text-center" data-id="element-367">
                <div className="text-4xl font-bold text-blue-900 mb-2" data-id="element-368">
                  12.500
                </div>
                <div className="text-sm text-gray-600" data-id="element-369">Pescadores ativos</div>
              </div>
              <div className="text-center" data-id="element-370">
                <div className="text-4xl font-bold text-blue-900 mb-2" data-id="element-371">45</div>
                <div className="text-sm text-gray-600" data-id="element-372">Espécies comerciais</div>
              </div>
            </div>
            <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold hover:bg-blue-800 transition-colors" data-id="element-373">
              Ver Relatório Completo
            </button>
          </div>
        </div>
      </section>
      {/* Financiamentos */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-374">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-375">
          Financiamentos e Apoios ao Setor
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-376">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-377">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-378">
              Linhas de Crédito Disponíveis
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-379">
              <li className="flex items-start gap-3" data-id="element-380">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-381" />
                <span className="text-gray-600" data-id="element-382">
                  Aquisição e modernização de embarcações
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-383">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-384" />
                <span className="text-gray-600" data-id="element-385">
                  Equipamentos de pesca e segurança
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-386">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-387" />
                <span className="text-gray-600" data-id="element-388">Projetos de aquacultura</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-389">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-390" />
                <span className="text-gray-600" data-id="element-391">
                  Infraestruturas de processamento
                </span>
              </li>
            </ul>
            <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-392">
              Candidatar-se
            </button>
          </div>
          <div className="bg-blue-50 rounded-lg p-6" data-id="element-393">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-394">
              Fundo Autónomo das Pescas
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-395">
              O Fundo Autónomo das Pescas disponibiliza apoios financeiros para
              projetos de desenvolvimento do setor pesqueiro, incluindo
              subsídios e empréstimos com condições favoráveis.
            </p>
            <a href="#" className="text-blue-900 font-semibold hover:underline" data-id="element-396">
              Saber mais sobre os apoios →
            </a>
          </div>
        </div>
      </section>
      {/* Infraestruturas */}
      <section className="bg-white py-16" data-id="element-397">
        <div className="max-w-7xl mx-auto px-4" data-id="element-398">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-399">
            Infraestruturas e Logística
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-400">
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-401">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-402">Portos de Pesca</h4>
              <p className="text-sm text-gray-600 mb-4" data-id="element-403">
                Infraestruturas portuárias dedicadas à atividade pesqueira
              </p>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-404">
                <li data-id="element-405">• Porto de Mindelo</li>
                <li data-id="element-406">• Porto da Praia</li>
                <li data-id="element-407">• Porto de São Vicente</li>
                <li data-id="element-408">• Cais de Tarrafal</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-409">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-410">
                Frigoríficos e Armazenamento
              </h4>
              <p className="text-sm text-gray-600 mb-4" data-id="element-411">
                Unidades de conservação e processamento de pescado
              </p>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-412">
                <li data-id="element-413">• Câmaras frigoríficas</li>
                <li data-id="element-414">• Fábricas de gelo</li>
                <li data-id="element-415">• Unidades de processamento</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-416">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-417">
                Serviços de Apoio
              </h4>
              <p className="text-sm text-gray-600 mb-4" data-id="element-418">
                Serviços essenciais para a frota pesqueira
              </p>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-419">
                <li data-id="element-420">• Abastecimento de combustível</li>
                <li data-id="element-421">• Reparação naval</li>
                <li data-id="element-422">• Fornecimento de gelo</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Mercado e Comercialização */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-423">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-424">
          Mercado, Comercialização e Exportações
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-425">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-426">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-427">
              Cadeia de Valor do Pescado
            </h3>
            <div className="space-y-4" data-id="element-428">
              <div className="flex items-center gap-4" data-id="element-429">
                <div className="w-8 h-8 bg-blue-900 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-430">
                  1
                </div>
                <div data-id="element-431">
                  <h4 className="font-semibold text-gray-900" data-id="element-432">Captura</h4>
                  <p className="text-sm text-gray-600" data-id="element-433">
                    Pesca artesanal e industrial
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-434">
                <div className="w-8 h-8 bg-blue-900 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-435">
                  2
                </div>
                <div data-id="element-436">
                  <h4 className="font-semibold text-gray-900" data-id="element-437">Desembarque</h4>
                  <p className="text-sm text-gray-600" data-id="element-438">
                    Portos e cais de pesca
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-439">
                <div className="w-8 h-8 bg-blue-900 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-440">
                  3
                </div>
                <div data-id="element-441">
                  <h4 className="font-semibold text-gray-900" data-id="element-442">Processamento</h4>
                  <p className="text-sm text-gray-600" data-id="element-443">
                    Conservação e transformação
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-444">
                <div className="w-8 h-8 bg-blue-900 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-445">
                  4
                </div>
                <div data-id="element-446">
                  <h4 className="font-semibold text-gray-900" data-id="element-447">
                    Comercialização
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-448">
                    Mercado nacional e exportação
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-900 text-white rounded-lg p-6" data-id="element-449">
            <h3 className="text-xl font-bold mb-4" data-id="element-450">Exportações</h3>
            <p className="mb-4" data-id="element-451">
              Cabo Verde exporta pescado fresco, congelado e transformado para
              diversos mercados internacionais
            </p>
            <div className="space-y-3 mb-6" data-id="element-452">
              <div data-id="element-453">
                <h4 className="font-semibold mb-1" data-id="element-454">Principais Mercados</h4>
                <p className="text-sm" data-id="element-455">
                  União Europeia, África Ocidental, Ásia
                </p>
              </div>
              <div data-id="element-456">
                <h4 className="font-semibold mb-1" data-id="element-457">Requisitos Sanitários</h4>
                <p className="text-sm" data-id="element-458">
                  Certificação HACCP e conformidade com normas internacionais
                </p>
              </div>
            </div>
            <button className="bg-white text-blue-900 px-6 py-2 rounded font-semibold" data-id="element-459">
              Guia de Exportação
            </button>
          </div>
        </div>
      </section>
      {/* Comunidades Costeiras */}
      <section className="bg-white py-16" data-id="element-460">
        <div className="max-w-7xl mx-auto px-4" data-id="element-461">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-462">
            Comunidades Costeiras e Pescadores Artesanais
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-463">
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-464">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-465">
                Perfil Socioeconómico
              </h4>
              <p className="text-sm text-gray-600" data-id="element-466">
                As comunidades costeiras representam cerca de 60% da população
                de Cabo Verde, com forte dependência da pesca artesanal como
                meio de subsistência.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-467">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-468">Artes de Pesca</h4>
              <p className="text-sm text-gray-600 mb-3" data-id="element-469">
                Técnicas tradicionais e modernas utilizadas pelos pescadores
              </p>
              <ul className="text-sm text-gray-600 space-y-1" data-id="element-470">
                <li data-id="element-471">• Linha de mão</li>
                <li data-id="element-472">• Redes de emalhar</li>
                <li data-id="element-473">• Armadilhas (covos)</li>
                <li data-id="element-474">• Pesca industrial</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-475">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-476">
                Apoios e Formação
              </h4>
              <p className="text-sm text-gray-600 mb-3" data-id="element-477">
                Programas de capacitação e segurança
              </p>
              <ul className="text-sm text-gray-600 space-y-1" data-id="element-478">
                <li data-id="element-479">• Formação profissional</li>
                <li data-id="element-480">• Segurança no mar</li>
                <li data-id="element-481">• Gestão de negócios</li>
                <li data-id="element-482">• Equipamentos de segurança</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Formação e Investigação */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-483">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-484">
          Formação, Investigação e Dados Científicos
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-485">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-486">
            <BookOpenIcon className="w-12 h-12 text-blue-900 mb-4" data-id="element-487" />
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-488">
              Institutos de Investigação
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-489">
              O Instituto do Mar (IMAR) e parceiros internacionais desenvolvem
              investigação científica sobre recursos marinhos, biodiversidade e
              sustentabilidade.
            </p>
            <div className="space-y-2" data-id="element-490">
              <a href="#" className="block text-blue-900 font-semibold text-sm hover:underline" data-id="element-491">
                → Relatórios científicos
              </a>
              <a href="#" className="block text-blue-900 font-semibold text-sm hover:underline" data-id="element-492">
                → Publicações e estudos
              </a>
              <a href="#" className="block text-blue-900 font-semibold text-sm hover:underline" data-id="element-493">
                → Dados de monitoramento
              </a>
            </div>
          </div>
          <div className="bg-blue-50 rounded-lg p-6" data-id="element-494">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-495">
              Capacitação Profissional
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-496">
              Programas de formação para pescadores, técnicos e gestores do
              setor pesqueiro
            </p>
            <ul className="space-y-2 mb-6" data-id="element-497">
              <li className="flex items-start gap-3" data-id="element-498">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-499" />
                <span className="text-gray-600 text-sm" data-id="element-500">
                  Técnicas de pesca sustentável
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-501">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-502" />
                <span className="text-gray-600 text-sm" data-id="element-503">
                  Segurança marítima
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-504">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-505" />
                <span className="text-gray-600 text-sm" data-id="element-506">
                  Gestão e comercialização
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-507">
                <div className="w-2 h-2 bg-blue-900 rounded-full mt-2 flex-shrink-0" data-id="element-508" />
                <span className="text-gray-600 text-sm" data-id="element-509">
                  Qualidade e higiene alimentar
                </span>
              </li>
            </ul>
            <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-510">
              Ver Cursos Disponíveis
            </button>
          </div>
        </div>
      </section>
      {/* Riscos e Desafios */}
      <section className="bg-white py-16" data-id="element-511">
        <div className="max-w-7xl mx-auto px-4" data-id="element-512">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-513">
            Riscos, Desafios e Oportunidades
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-514">
            <div className="bg-red-50 rounded-lg p-6 border-l-4 border-red-500" data-id="element-515">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-516">Desafios</h4>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-517">
                <li data-id="element-518">• Mudanças climáticas</li>
                <li data-id="element-519">• Sobreexploração de recursos</li>
                <li data-id="element-520">• Pesca ilegal (INN)</li>
                <li data-id="element-521">• Envelhecimento da frota</li>
                <li data-id="element-522">• Limitações infraestruturais</li>
              </ul>
            </div>
            <div className="bg-yellow-50 rounded-lg p-6 border-l-4 border-yellow-500" data-id="element-523">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-524">Riscos</h4>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-525">
                <li data-id="element-526">• Alterações nos stocks pesqueiros</li>
                <li data-id="element-527">• Acidentes marítimos</li>
                <li data-id="element-528">• Variabilidade climática</li>
                <li data-id="element-529">• Concorrência internacional</li>
                <li data-id="element-530">• Degradação de habitats</li>
              </ul>
            </div>
            <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-500" data-id="element-531">
              <h4 className="font-bold text-gray-900 mb-3" data-id="element-532">Oportunidades</h4>
              <ul className="text-sm text-gray-600 space-y-2" data-id="element-533">
                <li data-id="element-534">• Crescimento da aquacultura</li>
                <li data-id="element-535">• Inovação tecnológica</li>
                <li data-id="element-536">• Mercados de exportação</li>
                <li data-id="element-537">• Turismo de pesca desportiva</li>
                <li data-id="element-538">• Economia azul</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Recursos para Download */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-539">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-540">
          Recursos para Download / Links Úteis
        </h2>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-541">
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-542">
            <DownloadIcon className="w-10 h-10 text-blue-900 mb-4" data-id="element-543" />
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-544">
              Documentos e Formulários
            </h3>
            <div className="space-y-3" data-id="element-545">
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-546">
                <span className="text-gray-700" data-id="element-547">
                  Formulário de Registo de Embarcação
                </span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-548" />
              </a>
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-549">
                <span className="text-gray-700" data-id="element-550">
                  Pedido de Licença de Pesca
                </span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-551" />
              </a>
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-552">
                <span className="text-gray-700" data-id="element-553">Guia de Boas Práticas</span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-554" />
              </a>
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-555">
                <span className="text-gray-700" data-id="element-556">
                  Manual de Segurança Marítima
                </span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-557" />
              </a>
            </div>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-558">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-559">
              Legislação e Regulamentos
            </h3>
            <div className="space-y-3" data-id="element-560">
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-561">
                <span className="text-gray-700" data-id="element-562">Lei das Pescas (PDF)</span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-563" />
              </a>
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-564">
                <span className="text-gray-700" data-id="element-565">
                  Regulamento de Aquacultura (PDF)
                </span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-566" />
              </a>
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-567">
                <span className="text-gray-700" data-id="element-568">Normas Sanitárias (PDF)</span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-569" />
              </a>
              <a href="#" className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors" data-id="element-570">
                <span className="text-gray-700" data-id="element-571">Bases de Dados e Mapas</span>
                <DownloadIcon className="w-5 h-5 text-blue-900" data-id="element-572" />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Contactos */}
      <section className="bg-blue-900 text-white py-16" data-id="element-573">
        <div className="max-w-7xl mx-auto px-4" data-id="element-574">
          <h2 className="text-3xl font-bold mb-8" data-id="element-575">
            Contacto e Atendimento ao Público
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-576">
            <div data-id="element-577">
              <PhoneIcon className="w-10 h-10 mb-4" data-id="element-578" />
              <h3 className="text-xl font-bold mb-4" data-id="element-579">Sede Nacional</h3>
              <p className="mb-2" data-id="element-580">Direção Nacional de Pescas e Aquacultura</p>
              <p className="mb-2" data-id="element-581">Praia, Santiago</p>
              <p className="mb-2" data-id="element-582">Tel: +238 260 1234</p>
              <p className="mb-4" data-id="element-583">Email: pescas@gov.cv</p>
              <p className="text-sm" data-id="element-584">Horário: Segunda a Sexta, 8h00 - 16h00</p>
            </div>
            <div data-id="element-585">
              <h3 className="text-xl font-bold mb-4" data-id="element-586">Postos Regionais</h3>
              <div className="space-y-3 text-sm" data-id="element-587">
                <div data-id="element-588">
                  <p className="font-semibold" data-id="element-589">Mindelo, São Vicente</p>
                  <p data-id="element-590">Tel: +238 232 5678</p>
                </div>
                <div data-id="element-591">
                  <p className="font-semibold" data-id="element-592">Sal Rei, Boa Vista</p>
                  <p data-id="element-593">Tel: +238 251 9012</p>
                </div>
                <div data-id="element-594">
                  <p className="font-semibold" data-id="element-595">Santa Maria, Sal</p>
                  <p data-id="element-596">Tel: +238 242 3456</p>
                </div>
              </div>
            </div>
            <div data-id="element-597">
              <h3 className="text-xl font-bold mb-4" data-id="element-598">Atendimento Online</h3>
              <p className="mb-4" data-id="element-599">
                Para questões gerais e pedidos de informação
              </p>
              <button className="bg-white text-blue-900 px-6 py-2 rounded font-semibold hover:bg-gray-100 transition-colors" data-id="element-600">
                Enviar Mensagem
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-601">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-602">
          FAQ para Pescadores
        </h2>
        <div className="space-y-4" data-id="element-603">
          {[{
          question: 'Como posso registar a minha embarcação de pesca?',
          answer: 'O registo de embarcações é feito presencialmente nos serviços da Direção Nacional de Pescas. É necessário apresentar documentos de propriedade, certificado de navegabilidade e documentos de identificação do proprietário.'
        }, {
          question: 'Que tipos de licenças de pesca existem?',
          answer: 'Existem licenças para pesca artesanal, semi-industrial e industrial. Cada tipo tem requisitos específicos e áreas de operação definidas.'
        }, {
          question: 'Como posso aceder aos apoios financeiros?',
          answer: 'Os pedidos de financiamento devem ser submetidos ao Fundo Autónomo das Pescas através dos formulários disponíveis online ou nos postos de atendimento.'
        }, {
          question: 'Quais são os períodos de defeso?',
          answer: 'Os períodos de defeso variam conforme a espécie. Consulte o calendário de defesos atualizado nos serviços de pescas ou no portal online.'
        }, {
          question: 'Como denunciar pesca ilegal?',
          answer: 'Pode denunciar atividades de pesca ilegal através da linha direta +238 260 1234 ou pelo email fiscalizacao@pescas.gov.cv'
        }].map((faq, index) => <div key={index} className="bg-white rounded-lg p-6 shadow-sm" data-id="element-604">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-605">
                {faq.question}
              </h3>
              <p className="text-gray-600" data-id="element-606">{faq.answer}</p>
            </div>)}
        </div>
      </section>
      <Footer data-id="element-607" />
    </div>;
}